import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { TenantContractContext, updateTenantContractContext } from "@eres/ejari-core/contexts/TenantContractContext";
import { LoadableDataState, showMessage } from "@my-dld/utils/UIUtils";
import { MoveOut, ValidateDewaMoveOut } from "@eres/ejari-api/Entity/contract";
import _ from "lodash";
import { checkNonEmpty } from "../../utils";
import { RenderDewaMoveTo } from "../Contract/MoveOutInfo";
import { navigate } from "@my-dld/utils/StoreUtils";
import FormRow from "@eres/forms-web/FormRow";
import FormAction from "@my-dld/components/Form/FormAction";
import Strings from "@my-dld/assets/strings";
import { EjariPropertyType } from "@my-dld/utils/PropertyUtils";
import { getAppServices } from "@10x/coreapp";
import { Tenant } from "@eres/ejari-api/Entity/tenant";
import { EjariApi } from "@eres/ejari-api";
import { TenancyContactAction } from "@eres/ejari-core/constants";

interface Props extends RoutedViewProps {

}

export interface MoveOutState extends LoadableDataState, MoveOut {
	isValid: boolean;
}

class MoveOutInfo extends Component<Props, MoveOutState> {
	static contextType = TenantContractContext;
	context!: React.ContextType<typeof TenantContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			loadState: "done",
			isValid: false,
		};
	}

	componentDidMount() {
		const { contract, contractInfo, moveOut } = this.context;
		let startDate = contract ? contract.ContractStartDate : contractInfo ? contractInfo.ContractStartDate : undefined;
		this.setState( {
			DewaMoveinDate: startDate,
			DewaMoveoutDate: moveOut ? moveOut.DewaMoveoutDate : undefined,
			DewaMoveoutcontractNumber: moveOut ? moveOut.DewaMoveoutcontractNumber : undefined,
		} );
	}

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<MoveOutState>, snapshot?: any ) {
		if ( !_.isEqual( prevState, this.state ) )
			this.updateValidity();
	}

	updateValidity = () => {
		const state = this.state;
		let isValid: boolean = true;
		let errorContainer: {} = [];
		isValid = checkNonEmpty( state, "DewaMoveinDate", errorContainer ) && isValid;
		isValid = checkNonEmpty( state, "DewaMoveoutDate", errorContainer ) && isValid;
		isValid = checkNonEmpty( state, "DewaMoveoutcontractNumber", errorContainer ) && isValid;
		this.setState( {
			isValid: isValid,
		} );
	};

	render() {
		const { action } = this.context;
		const { isValid } = this.state;
		return <div className="tender-registration-form">
			<RenderDewaMoveTo state={ this.state } holder={ this } onSkip={ this.onSkip }/>
			<FormRow>
				{ action === TenancyContactAction.UPDATE_CONTRACT ?
					<FormAction
						disablePrimaryAction={ !isValid }
						groupClassName={ "text-center" }
						primaryActionLabel={ Strings.save }
						onPrimaryAction={ this.onSave }
						secondaryActionLabel={ Strings.back }
						onSecondaryAction={ this.onBack }/> :
					<FormAction
						disablePrimaryAction={ !isValid }
						groupClassName={ "text-center" }
						primaryActionLabel={ Strings.continue }
						onPrimaryAction={ this.onContinue }
						secondaryActionLabel={ Strings.back }
						onSecondaryAction={ this.onBack }/>
				}
			</FormRow>
		</div>;
	}

	getUpdatedData = ( state: MoveOutState = this.state ) => {
		const data: MoveOut = _.pick( state, "DewaMoveinDate", "DewaMoveoutDate", "DewaMoveoutcontractNumber" );
		return data;
	};

	private onSave = () => {
		let { contract } = this.context;
		let data: MoveOut = this.getUpdatedData();
		contract = {
			...contract,
			...data,
		};
		updateTenantContractContext( { contract: contract, moveOut: data, canResubmit: true } );
		this.onBack();
	};

	private onSkip = () => {
		updateTenantContractContext( { moveOut: undefined } );
		const { isCommercial } = this.context;
		navigate( isCommercial ? "commercial" : "documents" );
	};

	private onContinue = () => {
		const { contract, property, contractInfo, isCommercial } = this.context;
		const c = contract ?? contractInfo;
		if ( c && property ) {
			this.setState( { loadState: "loading" } );
			let data: MoveOut = {
				...this.getUpdatedData(),
			};
			const propertyId = property.EjariPropertyId ? property.EjariPropertyId : property.PropertyTypeId === EjariPropertyType.UNIT ? property.UnitEjariPropertyId :
				property.VillaEjariPropertyId;
			const tenantId = getAppServices().storeService.getStore().getState().User.tenantId;
			let tenant: Tenant = {
				TenantParticipantId: 0,
				Identity: 0,
				TenantId: tenantId,
				IsPrimary: true,
			};
			let m: ValidateDewaMoveOut = {
				...data,
				DewaMoveoutRequestno: this.state.DewaMoveoutcontractNumber,
				ContractStartDate: c.ContractStartDate!,
				ContractEndDate: c.ContractEndDate!,
				EjariPropertyId: [
					Number( propertyId ),
				],
				Tenants: [ tenant ],
			};
			EjariApi.validateDewaMoveOut( m ).then( rs => {
				this.setState( { loadState: "done" } );
				updateTenantContractContext( {
					moveOut: data,
				} );
				navigate( isCommercial ? "commercial" : "documents" );
			} ).catch( ex => {
				this.setState( { loadState: "done" } );
				showMessage( ex.toString() );
			} );
		} else {
			this.onBack();
		}
	};

	private onBack = () => {
		this.props.history.goBack();
	};
}

export default MoveOutInfo;
